module.exports = __webpack_public_path__ + "static/img/viral_17.28428925.jpg";